import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { LinkExternal } from 'cstar-react-primitives/lib/redux-form/LinkExternal';

export const FOOTER_CLASS = 'footer-links__a';

export const CashstarLink = ({
    linkText,
    url,
    external
}) => {
    const linkProps = {
        url,
        cssClass: FOOTER_CLASS
    };
    return (
        <Fragment>
            {external
                ? <LinkExternal {...linkProps}>{linkText}</LinkExternal>
                : <Link to={url} className={FOOTER_CLASS}>{linkText}</Link>
            }
        </Fragment>
    );
};

CashstarLink.defaultProps = {
    external: true
};

CashstarLink.propTypes = {
    linkText: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    external: PropTypes.bool
};

export default CashstarLink;
